import { render, staticRenderFns } from "./dailyRoomWisePresentList.vue?vue&type=template&id=379f05ce&"
import script from "./dailyRoomWisePresentList.vue?vue&type=script&lang=js&"
export * from "./dailyRoomWisePresentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports